import { NgModule } from '@angular/core';
import { LocalizedDatePipe } from '../shared/pipes/orwi-date.pipe';
import { ArrayFilterPipe } from '../shared/pipes/array-filter.pipe';
import { ArraySorterPipe } from '../shared/pipes/array-sorter.pipe';
import { MaxDatePipe } from '../shared/pipes/max-date.pipe';



const PIPES = [
    LocalizedDatePipe,
    ArrayFilterPipe,
    ArraySorterPipe,
    MaxDatePipe
];

@NgModule({
    imports: [],
    declarations: [...PIPES],
    providers: [],
    exports: [...PIPES]
})
export class PipesModule {
}
